export default {
  mimeTypeSettingsHeader: 'Nastavenia {mimeType}',
  contentTypeSettingsHeader: 'Nastavenia obsahu',
  title: 'Exportovať {MIMEType}',
  submitLabel: 'Exportovať {MIMEType}',
};
